module.exports = __webpack_public_path__ + "static/media/DSC_0064.78bed8ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0064.jpg
// module id = 685
// module chunks = 0